export default "/_next/static/images/effect-right-4-fce30b3941c01a4649fbcf4c6ca74160.svg";